import {useTranslation} from 'react-i18next';
import {Button, type ButtonProps} from '@chekinapp/ui';
import ModalSheet, {type ModalSheetProps} from 'components/common/ModalSheet';
import StandardModalSheet, {
  type StandardModalSheetProps,
} from 'components/common/StandardModalSheet';

type InternalStandardModalSheetProps = Pick<StandardModalSheetProps, 'text' | 'buttons'>;
type InternalModalSheetProps = Pick<
  ModalSheetProps,
  'isOpenModalSheet' | 'withModalMobileCloseButton' | 'title' | 'closeOnDocumentClick'
>;

type NotificationModalProps = {
  buttonLabel?: string;
  onConfirm: () => void;
  onClose: () => void;
};
type Props = InternalStandardModalSheetProps &
  InternalModalSheetProps &
  NotificationModalProps;
function NotificationModal({
  buttonLabel,
  buttons,
  text,
  onConfirm,
  onClose,
  ...props
}: Props) {
  const {t} = useTranslation();

  const internalButtonProps = {
    children: buttonLabel || t('understood'),
    className:
      'standard-modal-sheet__button mx-auto mb-6 w-full max-w-[327px] kiosko:h-[114px] kiosko:w-[698px] kiosko:max-w-none kiosko:rounded-[56px] kiosko:text-kiosko-m kiosko:mb-[56px]',
    onClick: onConfirm,
    variant: 'primary',
  } satisfies ButtonProps;

  return (
    <ModalSheet {...props} handleCloseModal={onClose}>
      <StandardModalSheet
        buttons={buttons}
        content={!buttons ? <Button {...internalButtonProps} /> : undefined}
        text={text}
      />
    </ModalSheet>
  );
}

export {NotificationModal};
